import sortBudgetByPlaceType from 'businessTraveller/utils/sortBudgetByPlaceType'
import FormatCurrency from 'components/Common/FormatCurrency'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React, { useMemo } from 'react'
import styled from 'styled-components'

const Grid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: ${rem(8)};
`

interface Props {
  budgets: Array<App.BusinessTraveller.BusinessBudget>
}

export function BusinessTravellerBudgetInfoModal(props: Props) {
  const { budgets } = props

  const sortedBudgets = useMemo(() => sortBudgetByPlaceType(budgets), [budgets])

  return (
    <Modal
      title={`Multiple budgets found for ${sortedBudgets[0].name}`}
    >
      <Group direction="vertical" gap={16}>
        <BodyText variant="large">Your search results for this location are categorised under multiple budgets.</BodyText>
        <Group direction="vertical" gap={4}>
          <Grid>
            {sortedBudgets?.map(budget =>
              <>
                <b>{budget?.name}:</b>
                <FormatCurrency value={budget?.budget} format="roundedDollar" />/night
              </>,
            )}
          </Grid>
        </Group>
      </Group>
    </Modal>
  )
}
